const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.in",
  "yahoo.co.uk",
  "ymail.com",
  "rocketmail.com",
  "hotmail.com",
  "hotmail.co.uk",
  "hotmail.fr",
  "outlook.com",
  "live.com",
  "msn.com",
  "protonmail.com",
  "proton.me",
  "pm.me",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
]);

const EMAIL_PATTERN = /^[^\s@]+@([^\s@]+\.[^\s@]+)$/;

export function isBusinessEmail(email) {
  const match = EMAIL_PATTERN.exec(email.trim().toLowerCase());
  if (!match) return false;
  return !FREE_EMAIL_DOMAINS.has(match[1]);
}

export function isValidEmailFormat(email) {
  return EMAIL_PATTERN.test(email.trim().toLowerCase());
}
